const initialState = {
  show: false,
  message: ''
}

const xmlLoad = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_XML_LOAD':
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export default xmlLoad